export default __webpack_public_path__ + "static/media/macs-gmp3.3ba4f589.jpg";